/// <amd-module name="TFS/Admin/Common/Util/HtmlString" />

export function createMarkup(html: string): { __html: string } {
    return { __html: html };
}

